<template>
  <v-col cols="12" md="3" sm="3">
    <div class="card-resume rounded-lg" @click="openLoading(evento)">
      <v-img
        :src="evento.imagens.destaque || evento.imagens.imagem1"
        class="white--text align-end rounded-lg"
        gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,1.5)"
        height="130px"
      >
        <v-card-title
          class="font-weight-bold title-style"
          :class="{ 'title-style-mobile': !mdAndUp }"
        >
          <span class="limited-title">
            {{ evento.descricao }}
          </span>
        </v-card-title>
        <v-card-subtitle class="font-weight-bold" v-if="evento.dt_apresentacao">
          <v-icon :size="iconSize" color="#fff">mdi-calendar</v-icon>
          {{ formatDate(evento.dt_apresentacao) }}
          <v-icon :size="iconSize" color="#fff">mdi-clock</v-icon>
          {{ evento.hr_apresentacao }}
        </v-card-subtitle>
      </v-img>
      <v-expand-transition>
        <v-card-text class="rounded-lg" max-height="70">
          <v-row>
            <v-col class="pt-1 px-0">
              <p class="text-body-2 px-0">
                <v-icon> mdi-finance </v-icon>
                {{ itemsSoldText }} <b>{{ evento.qt_vendida }}</b>
              </p>
              <p class="text-body-2 px-0">
                <v-icon>mdi-cash</v-icon>
                {{ $t("producer-dashboard.total-revenue") }}:
                <b>{{ valueSold }}</b>
              </p>
            </v-col>
          </v-row>
        </v-card-text>
      </v-expand-transition>
      <v-chip v-if="closed" color="error" pill x-small class="combo-status">
        {{ $t("producer-dashboard.closed") }}
      </v-chip>
      <v-chip v-else color="success" pill x-small class="combo-status">
        {{ $t("producer-dashboard.active") }}
      </v-chip>
    </div>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import displayHelpers from "@/mixins/breakpoints.mixins";
import { formatDate } from "@/utils";

export default {
  name: "ResumeCard",
  mixins: [displayHelpers],
  props: {
    evento: {
      type: Object,
      required: true,
    },
    closed: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      resumeLoading: false,
      formatDate,
    };
  },
  computed: {
    ...mapGetters(["dashEventLoading", "dashEvent", "showDetails"]),
    totalInvoincing() {
      if (Math.sign(this.dashEvent.faturamento_total) === -1) {
        return {
          value: Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(Number.parseFloat(this.dashEvent.faturamento_total)),
          class: "negative-percent",
        };
      } else {
        return {
          value: Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(Number.parseFloat(this.dashEvent.faturamento_total)),
          class: "positive-percent",
        };
      }
    },
    rechargeEvents() {
      return this.evento.tipo === "RECARGA";
    },
    productEvents() {
      return this.evento.tipo === "VOUCHER";
    },
    itemsSoldText() {
      let text = `${this.$t("producer-dashboard.sold-tickets")}:`;
      if (this.rechargeEvents) {
        text = `${this.$t("producer-dashboard.sold-recharges")}:`;
      }
      if (this.productEvents) {
        text = `${this.$t("producer-dashboard.sold-products")}:`;
      }
      return text;
    },
    valueSold() {
      const valorVendido = Number.parseFloat(
        this.evento.valor_vendido.replace(/,/g, "")
      );
      const formattedValue = Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(valorVendido);
      return formattedValue;
    },
    imageSize() {
      return this.mdAndUp ? 80 : 70;
    },
    titleSize() {
      return this.mdAndUp ? "subtitle-1" : "body-2";
    },
    subtitleSize() {
      return this.mdAndUp ? "body-2" : "caption";
    },
    iconSize() {
      return this.mdAndUp ? "18px" : "18px";
    },
    paddingSize() {
      return this.mdAndUp ? "pa-6" : "pa-4";
    },
  },
  methods: {
    ...mapActions(["setDashEvent", "setDashCheckin"]),
    async openLoading(item) {
      this.$router.push({
        name: "resume",
        params: { id: item.idproduto },
      });

      localStorage.setItem("evento", JSON.stringify(item));
    },
  },
};
</script>
<style lang="scss" scoped>
.limited-title {
  font-size: 14px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.card-resume {
  position: relative;
  cursor: pointer;
  border-radius: 50px;
  box-shadow: 11px 11px 22px #d9d9d9, 11px 11px 22px #ffffff;
  transition: all 0.2s ease-in-out;
}

.card-resume:hover {
  transform: scale(1.05);
  box-shadow: 11px 11px 12px #d9d9d9, 11px 11px 22px #ffffff;
}
.combo-status {
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
}

.overlay-add {
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
}
</style>
